import { render } from "./UserLogin.vue?vue&type=template&id=1cb6ff83&scoped=true"
import script from "./UserLogin.vue?vue&type=script&lang=js"
export * from "./UserLogin.vue?vue&type=script&lang=js"

import "./UserLogin.vue?vue&type=style&index=0&id=1cb6ff83&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1cb6ff83"

export default script